import React from "react";
import { ShieldCheck, Headset, Wrench, Building2 } from "lucide-react";

export const ROLE_OPTIONS = [
  { id: "admin", label: "Admin", icon: ShieldCheck },
  { id: "dispatcher", label: "Dispatcher", icon: Headset },
  { id: "technician", label: "Technician", icon: Wrench },
  { id: "office_personnel", label: "Office Personnel", icon: Building2 },
];

export const ROLE_LABEL = Object.fromEntries(ROLE_OPTIONS.map((r) => [r.id, r.label]));

/** Segmented-style role selector. White when not selected, blue when selected. */
export default function RoleButtons({ value, onChange, disabled, size = "md", testidPrefix = "role" }) {
  const heightClass = size === "sm" ? "h-7 text-[11.5px]" : "h-9 text-[12.5px]";
  return (
    <div className="inline-flex flex-wrap items-center gap-1.5" data-testid={`${testidPrefix}-group`}>
      {ROLE_OPTIONS.map((r) => {
        const selected = r.id === value;
        const Icon = r.icon;
        return (
          <button
            key={r.id}
            type="button"
            onClick={() => !disabled && onChange?.(r.id)}
            disabled={disabled}
            data-testid={`${testidPrefix}-${r.id}`}
            data-selected={selected}
            className={`${heightClass} px-2.5 rounded-md border font-semibold flex items-center gap-1.5 transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
              selected
                ? "bg-[#2563EB] border-[#2563EB] text-white hover:bg-[#1D4ED8] shadow-sm"
                : "bg-white border-slate-200 text-slate-700 hover:border-blue-300 hover:bg-blue-50/40 hover:text-blue-700"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />
            {r.label}
          </button>
        );
      })}
    </div>
  );
}
